import React from 'react';
import { AccountPanelTypes } from '../../AccountPanelTypes';
import { PayRentTypes } from '../../PayRentTypes';
import { cardTypes } from '../../constants/cardTypeIcons';

export const CardTypeIcon = ({
  cardNumber,
}: AccountPanelTypes.TCardTypeIcon) => {
  if (cardNumber) {
    cardNumber = cardNumber.replace(/-/g, '');
    const detectedCard = cardTypes.filter((card) =>
      card.regex.test(cardNumber)
    );
    return (
      <div
        className="cardTypeIcon"
        dangerouslySetInnerHTML={{ __html: detectedCard[0]?.icon }}
      ></div>
    );
  }
  return <></>;
};

export const getCardType = (cardNumber: string) => {
  const detectedCard = cardTypes.filter((card) => card.regex.test(cardNumber));
  return detectedCard[0]?.name;
};

export const getCardTypeFromPaymentMethodId: PayRentTypes.TCardTypeFromMethodIdFunction =
  (paymentMethodData, preferredPaymentId) => {
    const cardType = paymentMethodData.data.find(
      (specificMethod) => specificMethod.id === preferredPaymentId
    );
    return cardType?.value.description;
  };

export const ExistingCardTypeIcon = ({ cardType }: { cardType: string }) => {
  const detectedCard = cardTypes.filter((card) => card.name === cardType);
  return (
    <>
      {detectedCard && (
        <div
          className="cardTypeIcon"
          dangerouslySetInnerHTML={{ __html: detectedCard[0]?.icon }}
        ></div>
      )}
    </>
  );
};
